"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var react_1 = __importStar(require("react"));
var MapBox_1 = __importDefault(require("./MapBox"));
var layers_1 = require("./layers");
var MapComponent = function (_a) {
    var mapBoxProps = _a.mapBoxProps, _b = _a.shouldCluster, shouldCluster = _b === void 0 ? true : _b, selectedPoint = _a.selectedPoint, data = _a.data;
    var mapRef = react_1.useRef(null);
    var images = [];
    var sources = [];
    var onRender = [];
    data === null || data === void 0 ? void 0 : data.forEach(function (layerdata) {
        var layer = layers_1.getLayerFromType(layerdata.pointType)({
            points: layerdata.points,
            data: data,
            mapBoxProps: mapBoxProps,
            shouldCluster: shouldCluster,
            onClick: layerdata.onClick,
            toolTipType: layerdata.toolTipType,
        });
        images = images.concat(layer.images);
        sources.push(layer);
        if (layer.onRender) {
            onRender.push(layer.onRender);
        }
    });
    react_1.useEffect(function () {
        if (mapRef.current && selectedPoint) {
            mapRef.current.fire("click", {
                lngLat: [selectedPoint.longitude, selectedPoint.latitude],
                point: mapRef.current.project([
                    selectedPoint.longitude,
                    selectedPoint.latitude,
                ]),
                originalEvent: {},
            });
        }
    }, [selectedPoint]);
    // @ts-ignore
    return (react_1.default.createElement(MapBox_1.default, __assign({}, mapBoxProps, { sources: sources, images: images, setMapRef: function (map) { return (mapRef.current = map); }, onRender: function (e, map) { return onRender.map(function (render) { return render(e, map); }); } })));
};
exports.default = MapComponent;
